import React from "react";
import { ListGroup, ListGroupItem } from "reactstrap";
import { Application } from "../../..";
import styles from "../../../Styles/AppSelectorList.module.scss";

type Props = {
  selectedAppId: string;
  apps: Application[];
  onSelectedAppChange: (selectedAppId: string) => void;
};

export default class AppSelectorList extends React.Component<Props> {
  render() {
    return (
      <ListGroup>
        {this.props.apps.map(el => {
          const isActive = el.rolePrefix === this.props.selectedAppId;
          return (
            <ListGroupItem
              key={el.rolePrefix}
              className={styles.appSelectorListItem}
              active={isActive}
              onClick={() => {
                this.props.onSelectedAppChange(el.rolePrefix);
              }}
            >
              {el.name}
            </ListGroupItem>
          );
        })}
      </ListGroup>
    );
  }
}
